import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import Nav from "@/components/site/Nav";
import ExploreBlezzings from "@/components/site/ExploreBlezzings";
import Footer from "@/components/site/Footer";
import BookConsultationDialog from "@/components/site/BookConsultationDialog";
import JoinUsDialog from "@/components/site/JoinUsDialog";
import FloatingActions from "@/components/site/FloatingActions";
import { track } from "@/lib/analytics";
import { usePageMeta } from "@/lib/usePageMeta";

export default function EcosystemPage() {
  const [bookOpen, setBookOpen] = useState(false);
  const [joinOpen, setJoinOpen] = useState(false);

  usePageMeta({
    title: "BLEZZINGS Ecosystem — Six Businesses, One Vision",
    description:
      "Connecting ideas, capital, capability and impact — six businesses: Growth Partners, Academy, Publications, Ventures, BLEZZ Talks, Foundation.",
    canonical: "https://blezzings.co/ecosystem",
    breadcrumbs: [
      { name: "Home", url: "https://blezzings.co/" },
      { name: "BLEZZINGS Ecosystem", url: "https://blezzings.co/ecosystem" },
    ],
  });

  const openBook = (source) => {
    track("book_consultation_open", { source });
    setBookOpen(true);
  };

  return (
    <div data-testid="ecosystem-page" className="relative">
      <Nav onBook={() => openBook("nav")} />
      <div className="pt-16 md:pt-20" aria-hidden />
      <ExploreBlezzings />

      {/* CTA */}
      <section className="py-20 md:py-24 bg-[#050505] text-white">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center">
          <p
            data-testid="ecosystem-closing"
            className="font-serif-display text-3xl sm:text-4xl leading-snug"
          >
            An ecosystem built to multiply possibilities.
          </p>
          <p
            data-testid="ecosystem-cta-lead"
            className="mt-5 text-white/70 leading-relaxed"
          >
            Strategy, learning, ideas, ventures and impact — connected
            opportunities to grow businesses and build capabilities.
          </p>
          <button
            data-testid="ecosystem-partner-btn"
            onClick={() => openBook("ecosystem-page")}
            className="group mt-8 inline-flex items-center gap-3 h-12 px-7 bg-white text-black text-[15px] font-medium hover:bg-zinc-200 transition-colors duration-300"
          >
            Partner with BLEZZINGS
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </button>
        </div>
      </section>

      <Footer onJoin={() => setJoinOpen(true)} />
      <FloatingActions onBook={() => openBook("floating")} />
      <BookConsultationDialog open={bookOpen} onOpenChange={setBookOpen} />
      <JoinUsDialog open={joinOpen} onOpenChange={setJoinOpen} />
    </div>
  );
}
